import isNotEmptyArray from '@travel/ui/utils/arrays';

import { FILTER_VALUE_MAP, QUERY_KEY_MAP } from 'constants/providerReview';

const MULTI_SELECT_KEY_FORMAT: Record<string, (option: string) => string> = {
  overallScores: (score) => `f_score_${score}`,
  stayedMonths: (month) => `f_time_${month}`,
  ageRanges: (age) => `f_age_${age}`,
  genders: (gender) => `f_sex_${gender}`,
  purposes: (purpose) => `f_obj_${purpose}`,
  companions: (companion) => `f_mem${companion}`,
  additionalInformation: (info) => `f_info_${info}`,
  topics: (topicName) => `f_topic_${topicName}`,
};

export function buildQueryString(queryObj: Record<string, any>): string {
  const params: [string, string][] = [];

  Object.entries(queryObj).forEach(([key, value]) => {
    const mappedKey = QUERY_KEY_MAP[key];

    if (!mappedKey || value === undefined || value === null) return;

    if (MULTI_SELECT_KEY_FORMAT[key]) {
      value.forEach((v: string) => {
        const mappedValue = FILTER_VALUE_MAP[key]?.[v] ?? v;

        params.push([MULTI_SELECT_KEY_FORMAT[key](mappedValue), '1']);
      });
    } else if (key === 'keywords') {
      if (isNotEmptyArray(value)) {
        params.push([mappedKey, value.join(' ')]);
      }
    } else if (key === 'sortBy') {
      const mappedValue = FILTER_VALUE_MAP.sortBy?.[value] ?? value;

      params.push([mappedKey, mappedValue]);
    } else {
      params.push([mappedKey, String(value)]);
    }
  });

  return new URLSearchParams(params).toString();
}
